import { useHover } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { restsSelectors } from '@spa/scenes/Plannings/redux/selectors'
import React from 'react'
import type { FC } from 'react'

import {
  CardInfo,
  CardTitle,
  CardWrapper,
  CardWrapperColors
} from '../../../Card'
import RestNote from '../../RestNote/RestNote'
import { RestCardFooter } from '../RestCardFooter'

type Props = {
  restId: number
  classNames?: {
    root?: string
    title?: string
  }
}
const RestCard: FC<Props> = ({ restId, classNames = {} }) => {
  const { ref, hovered } = useHover()

  const { t } = usePlanningTranslation()
  const rest = restsSelectors.useGetCachedById(restId)
  const range = { start: rest.starts_at, end: rest.ends_at }
  const absenceName = rest.rest_type
    ? t(`common.app:models.rests.${rest.rest_type}.name`)
    : t(`common.app:models.rests.default_rest.name`)

  return (
    <div ref={ref} className={classNames.root}>
      <CardWrapper color={CardWrapperColors.dark}>
        <CardTitle
          className={classNames.title}
          label={absenceName}
          fontColor='#fff'
        />
        <CardInfo.Container type='gray'>
          <CardInfo.Content>
            {hovered
              ? t('weekly.card.durationLabel', {
                  range
                })
              : t('common.dates:range.dateToMinHours', range)}
          </CardInfo.Content>
        </CardInfo.Container>
        <RestCardFooter>
          <RestNote rest={rest} />
        </RestCardFooter>
      </CardWrapper>
    </div>
  )
}

export default RestCard
